import { Breakpoint } from 'theme/Theme';
// eslint-disable-next-line no-restricted-imports
import { Container as MuiContainer, ContainerProps as MuiContainerProps } from '@material-ui/core';
import { css, useTheme } from '@emotion/react';
import React from 'react';

/**
 * Container is the primary page container. it provides the overall page padding and centers the content horizontally on larger screens.
 *
 * ```js
 * import { Container } from 'ui';
 * ```
 */
 

export type ContainerProps = Omit<MuiContainerProps, 'maxWidth'> & {
  maxWidth?: Breakpoint | false;
};

const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  ({ maxWidth, ...props }, ref) => {
    const {
      breakpoints: { values },
    } = useTheme();

    return (
      <MuiContainer
        ref={ref}
        css={[
          maxWidth === 'lgx' &&
            css`
              max-width: ${values.lgx}px;
            `,
        ]}
        maxWidth={maxWidth === 'lgx' ? false : maxWidth}
        {...props}
      />
    );
  }
);

export default Container;
